import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className="center-logo">
        <Link className="navbar-brand" to="/">
          <h2 className="text-white uppercase">
            cloudmingle
          </h2>
        </Link>
      </div>
      <header className="header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <nav className="navbar navbar-expand-lg navbar-light">
                <Link className="navbar-brand" to="/">
                  <h2 className="text-white uppercase">
                    cloudmingle
                  </h2>
                </Link>
                <button 
                  className="navbar-toggler" 
                  type="button" 
                  onClick={toggleMenu}
                  aria-controls="navbarScroll" 
                  aria-expanded={isMenuOpen} 
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon">
                    <i className="fa fa-bars"></i>
                  </span>
                </button>
                <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarScroll">
                  <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                      <Link className="nav-link" to="/">Home</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/review-hotel">Hotels Reviews</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/luxury-hotel">Luxury Hotels</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/boutique-hotel">Boutique Hotels</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/eco-friendly-hotels">Eco-Friendly Hotels</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/budget-hotels">Budget Hotels</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/casino-hotel">Casino Hotels</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about-us">About Us</Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact-us">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;